import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function MessageA99(props) {
  const siteKey = "6LctsPQkAAAAALjII4qRrZMPqR8cKjUrpFvmoo6v";

  const [showCaptcha, setShowCaptcha] = React.useState(false);

  const handleVerify = async (e) => {
    const value = await e;
    if (value) setShowCaptcha(true);
    props.actions.sendMessageWithCode(value, {
      name: "IGNORE-IN-MESSAGES-ARRAY",
      value: value,
    });
  };

  return (
    <div
      style={{
        marginTop: 8,
      }}
      className="captchaContainer"
    >
      {!showCaptcha && (
        <ReCAPTCHA sitekey={siteKey} onChange={(e) => handleVerify(e)} />
      )}
    </div>
  );
}
